import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Quando o Supabase usa só o Site URL (ex.: https://app.com/) em vez de /reset-password,
 * os tokens ficam na raiz (#access_token=…&type=recovery). Esta rota envia o usuário
 * para /reset-password preservando hash e query (PKCE usa ?code=).
 */
export function AuthRecoveryRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/reset-password') return;

    const hash = window.location.hash;
    const search = window.location.search;

    if (!hash) return;

    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    if (params.get('type') === 'recovery') {
      navigate({ pathname: '/reset-password', search, hash }, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
